import React from 'react';
import type { StoryLine } from '../../types/demo';
import { DialogueCard } from './DialogueCard';
interface DialogueListProps {
  lines: StoryLine[];
  className?: string;
}
export function DialogueList({
  lines,
  className = ''
}: DialogueListProps) {
  return <div className={`flex flex-col gap-3 ${className}`} data-id="element-539" data-mp="1n04o3bhlv4te">
      {lines.map((line, index) => <DialogueCard key={`${line.kind}-${index}`} line={line} data-id="element-540" data-mp="1iysxp3qwqfk5" data-mpi={index} />)}
    </div>;
}